export function LogoField(name: '', label: '', desc: '', file = '') {
  this.name = name;
  this.label = label;
  this.desc = desc;
  this.file = file;
}
